import InnerLayout from '~/components/InnerLayout';
import Fieldset from '~/components/commonUi/Fieldset';
import AddRegion from './AddRegion';
import Regions from './Regions';
import AdminForm from './AdminForm';
import CopyElection from './CopyElection';
import { getStore } from '~/mobx/AppStore';
import { observer } from 'mobx-react';
import React from 'react';
import { Region } from '~/definitions/region';

interface Props {
    regions: Region[];
    isDisabled: boolean;
}

const Admin = (props: Props) => {
    const { regions, isDisabled = false } = props;

    const leftPanel = (
        <>
            {!isDisabled && (
                <div className="mb-[20px]">
                    <Fieldset title="Legg til ny region">
                        <AddRegion />
                    </Fieldset>
                </div>
            )}
            {regions?.length ? (
                <Fieldset title="Regioner">
                    <Regions />
                </Fieldset>
            ) : null}
        </>
    );

    const content = (
        <Fieldset title="Admin">
            <AdminForm />
        </Fieldset>
    );

    return (
        <>
            <InnerLayout leftPanel={leftPanel} content={content} />
            <CopyElection />
        </>
    );
};

const AdminWithStore = () => {
    const { regionStore, generalSettingsStore } = getStore();

    return <Admin regions={regionStore.regions} isDisabled={generalSettingsStore.isSettingsDisabled} />;
};

export default observer(AdminWithStore);
